import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Status } from '@fiverr/fit';
import '@fiverr/globals';
import { GigCardShell, Media, Price, GigBadges, Rating, SellerInfo, SellerLevel, Title, Username, CollectGig, DeliveryTime } from '../shared';
import { getCurrency, adaptGigData, getGigAssets, isRisingTalent, gigCardExperiments, inPpcAdBadgeTest } from '../utils';
import translations from '../translations.en.json';

// TODO: clean up isFooterReversed and make this a functional component
class GigCard extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            unmounting: false,
            gigsAssets: []
        };

        this.onLinkClick = this.onLinkClick.bind(this);

        i18n.add(translations);
    }

    componentDidMount() {
        // Any data that requires the use of the window object
        // should be initialized here due to SSR restrictions.

        this.setState({ // eslint-disable-line
            gigPrice: getCurrency(this.props.gig.price_i, true),
            averagePrice: this.props.gig.average_price && getCurrency(this.props.gig.average_price, true),
            medianPrice: this.props.gig.median_price && getCurrency(this.props.gig.median_price, true)
        });
    }

    componentWillReceiveProps(next) {
        if (!this.state.gigsAssets.length && next.gigsAssets && next.gigsAssets.assets) {

            this.setState({
                gigsAssets: next.gigsAssets.assets
            });
        }
    }

    isFooterReversed(abTests) {
        const avgMedVariations = [2, 3];

        return abTests && avgMedVariations.indexOf(abTests.AVG_MEDIAN_PRICE_2) > -1;
    }

    getTooltipPositionClass() {
        const gigPosition = this.props.gigIndex + 1;
        let shouldBeRightAligned = false;

        switch (this.props.cardSize) {
            case 'large':
                shouldBeRightAligned = !(gigPosition % 3);
                break;
            case 'medium':
                shouldBeRightAligned = !(gigPosition % 4) || !((gigPosition + 1) % 4);
                break;
            default:
                break;
        }

        return shouldBeRightAligned ? 'hint--bottom-right' : 'hint--bottom';
    }

    onLinkClick(e, type = 'gig') {
        const {
            gig,
            onLinkClick
        } = this.props;

        onLinkClick(e, { type, gig });
    }

    render() {
        const {
                user,
                updateCollections,
                gig,
                context
            } = this.props,
            gigsAssets = this.state.gigsAssets;

        const inExperiment = gigCardExperiments(context.abTests),
            userId = user && user.userId || null,
            risingTalent = isRisingTalent(gig.type),
            shouldRenderRating = (gig.rating > 0 || gig.is_pro) && !risingTalent,
            isLimitedEdition = gig.is_limited_edition,
            shouldRenderDeliveryTime = inExperiment('GET_IT_BY'),
            showHighCompletionRate = inExperiment('HIGH_COMPLETION_RATE_GIG_BADGE') && gig.high_completion_rate,
            showRecentRatings = inExperiment('LAST_60_DAYS_RATINGS') && (!gig.is_pro && gig.last_60_days_rating_count > 0),
            isPlusPrice = inExperiment('PLUS_PRICE') || inExperiment('1532'),
            isProExperience = inExperiment('PRO_EXPERIENCE') && gig.is_pro,
            tooltipPositionClass = this.getTooltipPositionClass(),
            showSellerLevel = !risingTalent && !isProExperience;

        adaptGigData(gig, {context});

        return (
            <GigCardShell cardType="card" cacheKey={`gig_card-${gig.cacheKey}`} key={gig.gig_id} type="mp-gig-card" gigId={gig.gig_id} cachedSlug={gig.cached_slug} position={gig.pos} isProExperience={isProExperience} isLimitedEdition={isLimitedEdition}>
                <a key={`title-link-${gig.gig_id}`} href={gig.gig_url} className="js-gig-card-imp-data" onClick={this.onLinkClick}>
                    <Media key={`media-${gig.gig_id}`} assets={getGigAssets(gig, gigsAssets)} gigId={gig.gig_id} userId={userId}/>
                </a>
                {inPpcAdBadgeTest(gig.type) && <Status classes="ppc-badge">
                    {i18n.t('badges.ppc.caption')}
                </Status>}
                <div className="gig-card-caption">
                    <SellerInfo>
                        {gig.is_seller_online && <span className="is-online"></span>}
                        <Avatar src={gig.seller_img}/>
                        <div className="seller-info-wrapper">
                            <Username name={gig.seller_name} url={gig.seller_url}/>
                            {showSellerLevel && <SellerLevel level={gig.seller_level} isPro={gig.is_pro} isLimitedEdition={isLimitedEdition} isNewSeller={gig.is_new_seller} tooltipPositionClass={tooltipPositionClass}/>}
                        </div>
                    </SellerInfo>
                    <Title gigUrl={gig.gig_url}
                        caption={gig.iwill_title}
                        onLinkClick={this.onLinkClick}/>
                    <div className="rating-badges-container">
                        {shouldRenderRating && !isLimitedEdition && <Rating score={gig.rating} recentScore={gig.last_60_days_rating_avg} gigId={gig.gig_id} votes={gig.rating_count} recentRatingsCount={gig.last_60_days_rating_count} starSize={15} starCount={1} isPro={gig.is_pro} recentRatingsExp={showRecentRatings} isProExperience={isProExperience}/>}
                        <GigBadges featured={gig.is_featured}
                            limitedEdition={gig.is_limited_edition}
                            limitedEditionDeadline={gig.limited_edition_expires_at}
                            qualityChoice={gig.quality_choice}
                            reliable={showHighCompletionRate}
                            availableNow={gig.is_available_now}
                            type={gig.type}
                            sellerName={gig.seller_name}
                            pro={gig.is_pro}
                            gigId={gig.gig_id}
                            tooltipPositionClass={tooltipPositionClass}
                            isProExperience={isProExperience}/>
                    </div>
                </div>
                {shouldRenderDeliveryTime && <DeliveryTime deliveryTime={gig.fastest_delivery_time} gigUrl={gig.gig_url}/>}
                <footer className={`gig-card-footer${this.isFooterReversed(context.abTests) ? ' reversed' : ''}`}>
                    <CollectGig gigId={gig.gig_id} sellerId={gig.seller_id} updateCollections={updateCollections} user={user} showCollMenu={true} icon="ficon ficon-bars"/>
                    <Price gigUrl={gig.gig_url}
                        price={this.state.gigPrice}
                        showStartingAt={gig.show_starting_at}
                        isLimitedEdition={isLimitedEdition}
                        averagePrice={this.state.averagePrice}
                        isPlusPrice={isPlusPrice}
                        medianPrice={this.state.medianPrice}
                        onLinkClick={this.onLinkClick}/>
                </footer>
            </GigCardShell>
        );
    }
}

GigCard.propTypes = {
    user: PropTypes.object,
    gig: PropTypes.object,
    gigIndex: PropTypes.number,
    cardSize: PropTypes.string,
    context: PropTypes.shape({
        pageCtxId: PropTypes.string,
        refCtxId: PropTypes.string,
        abTests: PropTypes.object
    }),
    onLinkClick: PropTypes.func
};

GigCard.defaultProps = {
    context: {},
    onLinkClick: () => null
};

export default GigCard;



// WEBPACK FOOTER //
// ./src/mp_gig_card/GigCard.js